import { twMerge } from 'tailwind-merge';

interface InfosMessageProps {
  message?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  containerClassName?: string;
  messageClassName?: string;
}

export const InfosMessage = ({
  message,
  icon,
  children,
  containerClassName,
  messageClassName,
}: InfosMessageProps) => {
  return (
    <div
      className={twMerge(
        'flex items-center gap-2 p-4 bg-primary text-white rounded-md w-fit',
        containerClassName
      )}
    >
      {!children ? (
        <>
          {icon}
          <p className={messageClassName}>{message}</p>
        </>
      ) : (
        children
      )}
    </div>
  );
};
